import { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import { TagSelector } from "./TagSelector";
import { api } from "../../lib/api";

interface Tag {
  id: number;
  tag: string;
}

export const TagManager = () => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [newTag, setNewTag] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const fetchTags = useCallback(async () => {
    try {
      const data = await api.getTags();
      setTags([...data].sort((a, b) => a.tag.localeCompare(b.tag)));
    } catch {
      toast.error("タグの取得に失敗しました");
    }
  }, []);

  useEffect(() => {
    fetchTags();
  }, [fetchTags, refreshTrigger]);

  const handleAddTag = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newTag.trim()) return;

    setIsLoading(true);
    try {
      await api.createTag(newTag.trim());
      toast.success("タグを追加しました");
      setNewTag("");
      setRefreshTrigger((prev) => prev + 1);
    } catch {
      toast.error("タグの追加に失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteTag = async (id: number) => {
    if (!confirm("このタグを削除してもよろしいですか？")) return;

    try {
      await api.deleteTag(id);
      toast.success("タグを削除しました");
      setRefreshTrigger((prev) => prev + 1);
    } catch {
      toast.error("タグの削除に失敗しました");
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">タグ管理</h2>

      <form onSubmit={handleAddTag} className="flex gap-2">
        <input
          type="text"
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder="新しいタグ"
          className="px-3 py-2 border rounded"
        />
        <button
          type="submit"
          disabled={isLoading || !newTag.trim()}
          className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
        >
          追加
        </button>
      </form>

      <div className="mt-8">
        <h3 className="text-lg font-medium mb-4">既存のタグ一覧</h3>
        <TagSelector
          tags={tags}
          selectedTags={selectedTags}
          onTagsChange={setSelectedTags}
          showDeleteButton
          onDeleteTag={handleDeleteTag}
        />
      </div>
    </div>
  );
};
